import { FieldMapping, GponOnusField } from "./gpon-onus.models";

/**
 * Mapa entre @see GponOnusField e os respectivos campos paralelos ocultos que contém a URL do Zabbix.
 */
export const FIELD_URL_MAP: FieldMapping<string> = {
    [GponOnusField.RxPower]:     "rxPowerUrl",
    [GponOnusField.TxPower]:     "txPowerUrl",
    [GponOnusField.Eth1InRate]:  "eth1InRateUrl",
    [GponOnusField.Eth1OutRate]: "eth1OutRateUrl",
    [GponOnusField.Eth2InRate]:  "eth2InRateUrl",
    [GponOnusField.Eth2OutRate]: "eth2OutRateUrl",
    [GponOnusField.Eth3InRate]:  "eth3InRateUrl",
    [GponOnusField.Eth3OutRate]: "eth3OutRateUrl",
    [GponOnusField.Eth4InRate]:  "eth4InRateUrl",
    [GponOnusField.Eth4OutRate]: "eth4OutRateUrl"
}
